<template lang="pug">
  .card.address(
    :class="{ 'card--expand': isProgressState, 'card--done': isFinishedState }"
  )

    .card__head
      .titleStep
        cp-icon.titleStep__icon(
          v-if="!hasMobile"
          :path="`/icons/home${!isFinishedState ? '-off' : ''}.svg`"
        )
        h3.titleStep__title {{ titleStep }}

      .btnEdit(v-if="isFinishedState && !hasMobile"  @click="openStep")
        img.btnEdit__icon(src='@/assets/icons/edit.svg')
        span.btnEdit__label Editar

    .card__body.address__container(:class="expandContent")
      .address__row
        check-field.address__row__fieldZipcode(
          label="CEP"
          for="zipcode"
          id="zipcode"
          type="cep"
          name="zipcode"
          placeholder="Somente números"
          autofocus
          :value="zipcode"
          :validation="zipcodeValidation"
          :disabled="product.alias === 'residencial'"
          @change="setZipcode"
        )
      .address__row
        check-field(
          label="Endereço"
          for="streetName"
          id="streetName"
          type="text"
          name="streetName"
          placeholder="Rua, Avenida, Alameda"
          :value="streetName"
          :validation="streetNameValidation"
          :disabled="!product.allowChangeAddress"
          @change="setStreetName"
        )
        check-field.address__row__fieldStreetNumber(
          label="Número"
          for="streetNumber"
          id="streetNumber"
          type="tel"
          name="streetNumber"
          placeholder="4580"
          :mask="['##########']"
          :value="streetNumber"
          :validation="streetNumberValidation"
          @change="setStreetNumber"
        )
        check-field.address__row__fieldComplement(
          label="Complemento"
          lblInfo="(Opcional)"
          for="complement"
          id="complement"
          type="text"
          :maxlength="20"
          name="complement"
          :value="complement"
          :validation="complementValidation"
          @change="setComplement"
        )
      .address__row
        check-field(
          label="Bairro"
          for="neighborhood"
          id="neighborhood"
          type="text"
          name="neighborhood"
          :value="neighborhood"
          :validation="neighborhoodValidation"
          :disabled="!!neighborhood && !product.allowChangeAddress"
          @change="setNeighborhood"
        )
        check-field.address__row__fieldCity(
          label="Cidade"
          for="city"
          id="city"
          type="text"
          name="city"
          :value="city"
          :validation="cityValidation"
          :disabled="!product.allowChangeAddress"
          @change="setCity"
          )
        check-field.address__row__fieldState(
          isSelect
          label="Estado"
          id="state"
          :options="states"
          :value="state"
          :validation="stateValidation"
          :disabled="!product.allowChangeAddress"
          @change="setState"
        )
      .address__row
        cp-button.btn__nextStep(
          label="Continuar"
          size="medium"
          :disabled="isbtnDisabled"
          @onClick="nextStep"
        )
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import views from '@/mixins/views'
import dataLayer from '@/utils/data-layer'
import { PROGRESS_STATE, FINISHED_STATE } from '@/stateSteps'
import { numeric, minLength, helpers, required } from 'vuelidate/lib/validators'

import CpIcon from '@/components/atoms/Icon.vue'
import CheckField from '@/components/molecules/Field.vue'
import cpButton from '@/components/atoms/Button.vue'

const REGEX_CHECK_ZIPCODE = /^\D*(?:\d\D*){8}$/

export default {
  name: 'Address',
  mixins: [views],
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showStepClass: 'active',
      states: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
      hasMobile: '',
      oldZipCode: null
    }
  },
  components: {
    CpIcon,
    CheckField,
    cpButton
  },
  watch: {
    zipcode (newValue) {
      newValue = newValue.replace(/\D*/g, '')

      if (REGEX_CHECK_ZIPCODE.test(newValue) && (newValue !== this.oldZipCode)) {
        this.getAddressByPostalCode({ zipcode: newValue })
          .then(() => {
            const elemID = this.streetName ? 'streetNumber' : 'streetName'

            document.getElementById(elemID) && document.getElementById(elemID).focus()

            this.oldZipCode = newValue
          })
      }
    }
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  mounted () {
    if (this.steps.address === 'finished') {
      this.$v.$touch()
    }
  },
  computed: {
    ...mapState(['configApp', 'product', 'address', 'steps']),
    titleStep () {
      return (
        this.isProgressState &&
        this.product.address &&
        this.product.address.title
      ) || 'Endereço'
    },
    expandContent () {
      return {
        'address__container--expand': this.steps.address === PROGRESS_STATE || this.hasMobile
      }
    },
    isProgressState () {
      return this.steps.address === PROGRESS_STATE || this.hasMobile
    },
    isFinishedState () {
      return this.steps.address === FINISHED_STATE
    },
    zipcode () {
      return this.address.zipcode
    },
    streetName () {
      return this.address.streetName
    },
    streetNumber () {
      return this.address.streetNumber
    },
    complement () {
      return this.address.complement
    },
    neighborhood () {
      return (this.address.neighborhood && this.address.neighborhood.replace(/^sem bairro$/ig, '')) || ''
    },
    city () {
      return this.address.city
    },
    state () {
      return this.address.state
    },
    zipcodeValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe um CEP',
          valid: false
        },
        {
          type: 'error',
          msg: 'Informe um CEP válido',
          valid: false
        }
      ]

      if (!this.$v.zipcode.$invalid && this.zipcode) return { valid: true }
      if (this.$v.zipcode.$dirty && this.$v.zipcode.$invalid) {
        if (!this.$v.zipcode.required) return validations[0]
        else return validations[1]
      }

      return {}
    },
    streetNameValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe um endereço',
          valid: false
        }
      ]
      if (!this.$v.streetName.$invalid && this.streetName) return { valid: true }
      if (this.$v.streetName.$dirty && this.$v.streetName.$invalid) return validations[0]

      return {}
    },
    streetNumberValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe o número',
          valid: false
        }
      ]
      if (!this.$v.streetNumber.$invalid && this.streetNumber) return { valid: true }
      if (this.$v.streetNumber.$dirty && this.$v.streetNumber.$invalid) return validations[0]

      return {}
    },
    complementValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe um complemento válido',
          valid: false
        }
      ]
      if (!this.$v.complement.$dirty && this.$v.complement.$invalid) return validations[0]

      return {}
    },
    neighborhoodValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe o nome do bairro',
          valid: false
        }
      ]
      if (!this.$v.neighborhood.$invalid && this.neighborhood) return { valid: true }
      if (this.$v.neighborhood.$dirty && this.$v.neighborhood.$invalid) return validations[0]

      return {}
    },
    cityValidation () {
      const validations = [
        {
          type: 'error',
          msg: 'Informe o nome da cidade',
          valid: false
        }
      ]
      if (!this.$v.city.$invalid && this.city) return { valid: true }
      if (this.$v.city.$dirty && this.$v.city.$invalid) return validations[0]

      return {}
    },
    stateValidation () {
      if (!this.$v.state.$invalid && this.state) return { valid: true }

      return {}
    },
    isbtnDisabled () {
      this.changeValidateStepAddress(!this.$v.$invalid)
      return this.$v.$invalid
    }
  },
  methods: {
    ...mapActions('lead', ['patchLeadAction']),
    ...mapActions('address', ['getAddressByPostalCode']),
    ...mapMutations('validatedSteps', [
      'changeValidateStepAddress'
    ]),
    ...mapMutations('address', [
      'changeAddressZipcode',
      'changeAddressStreetName',
      'changeAddressStreetNumber',
      'changeAddressComplement',
      'changeAddressNeighborhood',
      'changeAddressCity',
      'changeAddressState'
    ]),
    handleResize () {
      this.hasMobile = window.innerWidth < 767 && true
    },
    setZipcode (value) {
      this.setDirty(this.$v.zipcode)
      this.changeAddressZipcode(value)
    },
    setStreetName (value) {
      this.setDirty(this.$v.streetName)
      this.changeAddressStreetName(value)
    },
    setStreetNumber (value) {
      this.setDirty(this.$v.streetNumber)
      this.changeAddressStreetNumber(value)
    },
    setComplement (value) {
      this.setDirty(this.$v.complement)
      this.changeAddressComplement(value)
    },
    setNeighborhood (value) {
      this.setDirty(this.$v.neighborhood)
      this.changeAddressNeighborhood(value)
    },
    setCity (value) {
      this.setDirty(this.$v.city)
      this.changeAddressCity(value)
    },
    setState (value) {
      this.setDirty(this.$v.state)
      this.changeAddressState(value)
    },
    async nextStep () {
      this.steps.address = FINISHED_STATE
      this.steps.payment = PROGRESS_STATE
      this.steps.sendQuotation = PROGRESS_STATE
      this.steps.termsAndConditions = PROGRESS_STATE

      dataLayer({
        event: `${this.product.alias}-semprebem`,
        category: `${this.product.alias}-endereco`,
        action: 'click',
        label: 'continuar-2'
      })

      await this.patchLeadAction({
        leadAdditionalInformation: {
          neighbourhood: this.neighborhood,
          city: this.city,
          state: this.state
        }
      })

      if (this.configApp.isOperator) {
        this.$router.push({ name: 'sendQuotation' })
      } else if (this.configApp.isEmployee) {
        this.$router.push({ name: 'termsAndConditions' })
      } else {
        this.$router.push({ name: 'payment' })
      }
    },
    openStep () {
      this.$router.push({ name: 'address' })

      this.steps.personalData = FINISHED_STATE
      this.steps.address = PROGRESS_STATE
      this.steps.payment = this.steps.payment !== 'initial' ? 'finished' : 'initial'
      this.steps.sendQuotation = this.steps.sendQuotation !== 'initial' ? 'finished' : 'initial'
      this.steps.termsAndConditions = this.steps.termsAndConditions !== 'initial' ? 'finished' : 'initial'
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  validations: {
    zipcode: {
      required,
      cep: helpers.regex('cep', REGEX_CHECK_ZIPCODE)
    },
    streetName: {
      required,
      alphaNumWhiteDiacritic: helpers.regex('alphaNumWhiteDiacritic', /^[a-zA-Z0-9À-ž\s.\-'/ªº"()]*$/),
      minLength: minLength(2)
    },
    streetNumber: {
      required,
      numeric
    },
    complement: {
      alphaNumWhiteDiacritic: helpers.regex('alphaNumWhiteDiacritic', /^[a-zA-Z0-9À-ž\s.,\-'/ªº"()]*$/)
    },
    neighborhood: {
      required,
      alphaNumWhiteDiacritic: helpers.regex('alphaNumWhiteDiacritic', /^[a-zA-Z0-9À-ž\s.\-'/ªº"()]*$/),
      minLength: minLength(2)
    },
    city: {
      required,
      alphaNumWhiteDiacritic: helpers.regex('alphaNumWhiteDiacritic', /^[a-zA-Z0-9À-ž\s.\-'"]*$/),
      minLength: minLength(2)
    },
    state: {
      required
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .address {
   &__container {
      display: none;

      &--expand {
        display: block;
      }
    }

    &__row {
      width: 100%;

      @media screen and (min-width: 768px) {
        display: flex;
      }

      &__fieldStreetNumber {
        @media screen and (min-width: 768px) {
          max-width: 114px;
        }
      }

      &__fieldComplement {
        @media screen and (min-width: 768px) {
          max-width: 200px;
        }
      }

      &__fieldCity {
        @media screen and (min-width: 768px) {
          max-width: 252px;
        }
      }

      &__fieldState {
        @media screen and (min-width: 768px) {
          max-width: 200px;
        }
      }
    }
  }
</style>
